module.exports = __webpack_public_path__ + "img/user-light.e4742907.svg";